import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { CourierEarningListResponse } from '../model/response/configuration-list.response';
import { DefaultResponseInterface } from '../model/response/default-response.interface';

@Injectable()
export class AdminConfigurationApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchList() {
    return this.http.get<CourierEarningListResponse>(
      this.baseUrl + '/api/cf/administration/configuration',
      {headers: this.getAuthHeaders()}
    );
  }

  public save(request) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + '/api/cf/administration/configuration',
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public update(id, request) {
    return this.http.put<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/configuration/${id}`,
      request,
      {headers: this.getAuthHeaders()}
    );
  }
}
